import { ReactElement } from 'react';
import { Svg } from '@hopskipdrive/react-components';
import { Sync as SyncIcon } from '@mui/icons-material';
import { includes } from 'lodash';

import { colorPalette, colorTokens } from '../../../shared/components/variables';
import { RIDE_STATES } from '../../constants/rideStates';

type LabelProps = {
  bgColor: string;
  border: string;
  textColor: string;
  icon?: ReactElement;
  label: string;
};

export const getStatusLabelProps = (state) => {
  let labelProps: LabelProps = {
    bgColor: '',
    border: '',
    textColor: '',
    icon: undefined,
    label: replaceUnderscoreWithSpacePascalCase(state),
  };

  switch (true) {
    case includes(RIDE_STATES.upcoming, state):
      labelProps = {
        ...labelProps,
        bgColor: colorPalette.yellow950,
        border: `1px solid ${colorTokens.warning.dark}`,
        textColor: colorTokens.text.primary,
        ...(state === 'in_cart' && { label: 'Unclaimed (in cart)' }),
      };
      break;
    case includes(RIDE_STATES.claimed, state):
      labelProps = {
        ...labelProps,
        bgColor: colorPalette.green975,
        border: `1px solid ${colorTokens.success.outlineBorder}`,
        textColor: colorTokens.text.primary,
      };
      break;
    case includes(RIDE_STATES.inProgress, state):
      labelProps = {
        ...labelProps,
        bgColor: colorPalette.green975,
        border: `1px solid ${colorTokens.success.outlineBorder}`,
        textColor: colorTokens.text.primary,
        ...(state === 'in_progress' && { icon: <SyncIcon style={{ color: colorTokens.text.primary }} /> }),
        ...(state === 'waiting' && { icon: <Svg icon="time" style={{ color: colorTokens.text.primary }} /> }),
      };
      break;
    case includes(RIDE_STATES.completed, state):
      labelProps = {
        ...labelProps,
        bgColor: colorPalette.purple900,
        border: `1px solid ${colorPalette.purple550}`,
        textColor: colorTokens.text.primary,
        icon: <Svg icon="checkered-flag" style={{ color: colorTokens.text.primary }} />,
      };
      break;
    case includes(RIDE_STATES.canceled, state):
      labelProps = {
        ...labelProps,
        bgColor: colorPalette.red975,
        border: `1px solid ${colorTokens.error.outlineBorder}`,
        textColor: colorTokens.text.primary,
      };
      break;
    case includes(RIDE_STATES.inactive, state):
      labelProps = {
        ...labelProps,
        bgColor: colorPalette.neutral400,
        textColor: colorTokens.text.contrast,
      };
      break;
    default:
      break;
  }

  return labelProps;
};

export const replaceUnderscoreWithSpacePascalCase = (state) => {
  return state?.replace(/_/g, ' ').replace(/\b\w/g, (l) => l.toUpperCase());
};

export const convertToSnakeCase = (str: string) => {
  return str
    .replace(/\s+/g, '_')
    .toLowerCase()
    .replace(/[^a-z0-9_]/g, '');
};

export const capitalizeFirstNameLastName = (fullName: string) => {
  return fullName
    .split(' ')
    .map((name) => name.charAt(0).toUpperCase() + name.slice(1))
    .join(' ');
};
